import React from 'react'
import { injectIntl, InjectedIntlProps } from 'react-intl'
import Tooltip from 'components/Tooltip'
import messages from './messages'
import styles from './BusinessZoneCount.scss'

interface BusinessZoneCountProps extends InjectedIntlProps {
  type: string
  counts?: {
    currentZone?: number
    total?: number
  }
}

const BusinessZoneCount: React.FC<BusinessZoneCountProps> = ({
  intl,
  type,
  counts = {
    currentZone: 0,
    total: 0,
  },
}) => (
  <span className={styles.container}>
    <Tooltip title={intl.formatMessage(messages.tooltips.currentZone, { type })}>
      <span className={styles.zone}>{counts.currentZone}</span>
    </Tooltip>
    <span className={styles.separator}>/</span>
    <Tooltip title={intl.formatMessage(messages.tooltips.total, { type })}>
      <span className={styles.total}>{counts.total && counts.total >= 1000 ? '1000+' : counts.total}</span>
    </Tooltip>
  </span>
)

export default injectIntl(BusinessZoneCount)

